import React, {useContext} from 'react';
import { VideoPlayer,ReactVideoProvider } from 'react-video-master';
import GeneralContext from "../context/GeneralProvider";
import '../player.css';


function Video() {
    const {video} = useContext(GeneralContext)

    return (
        <ReactVideoProvider>
            <div style={{width:"400px"}}>
            <VideoPlayer
                src={video}
                onPlay={() => console.log('Video started playing')}
                onPause={() => console.log('Video paused')}
                onEnded={() => console.log('Video ended')}
                paused={false}
            />
            </div>
        </ReactVideoProvider>
    );
}

export default Video;